import Helpers from '../modules/Helpers'
import isBrowserIE10 from '../modules/IsBrowserIE10'

const rangerSliders = document.getElementsByClassName('ranger-slider')

// Ensure correct event is used in IE 10 as
// 'input' event is buggy in IE 10
const event = isBrowserIE10() ? 'change' : 'input'

// When a slider inputs value is changed by sliding,
// change the corresponding output to show user
// their current selection.
new Helpers(rangerSliders).eventListener((e) => {
    e.preventDefault()

    const rangeSliderOutputId = e.target.getAttribute('aria-controls')
    const rangeSliderOutput = document.getElementById(rangeSliderOutputId)

    // When the value of the slider is greater the 1,
    // update the iner HTML of the corresponding output
    // element to reflect their selection.
    if (parseFloat(e.target.value) == 1) {
        rangeSliderOutput.innerHTML = `1 mile`
    } else if (parseFloat(e.target.value) > 0) {
        rangeSliderOutput.innerHTML = `${e.target.value} miles`
    } else {
        rangeSliderOutput.innerHTML = 'This area only'
    }
}, event)

new Helpers(rangerSliders).eventListener((e) => {
    const rangeSliderOutputId = e.target.getAttribute('aria-controls')
    const rangeSliderOutput = document.getElementById(rangeSliderOutputId)

    // When the value of the slider is greater the 1,
    // update the iner HTML of the corresponding output
    // element to reflect their selection.
    if (parseFloat(e.target.value) == 1) {
        rangeSliderOutput.innerHTML = `1 mile`
    } else if (parseFloat(e.target.value) > 0) {
        rangeSliderOutput.innerHTML = `${e.target.value} miles`
    } else {
        rangeSliderOutput.innerHTML = 'This area only'
    }
}, 'sync')
